import type { PropType } from 'vue'
import type { CSSColor, LineType } from './types'

/**
 * @description Timeline Props
 */
export const timelineProps = {
  /**
   * @description 是否倒序
   */
  reverse: {
    type: Boolean
  },
  /**
   * @description 轴线样式
   */
  lineType: {
    type: String as PropType<LineType>,
    default: 'dotted'
  }
}

/**
 * @description Item Props
 */
export const timelineItemProps = {
  /**
   * @description 小圆点颜色
   */
  dotColor: {
    type: String as PropType<CSSColor>
  }
}
